/**
 * theme.js - Global Interactivity (Vioniq OS 2.0)
 * All class references use vioniq- prefix.
 */

class VioniqTheme {
  constructor() {
    this.initStickyHeader();
    this.initMobileMenu();
  }

  initStickyHeader() {
    const header = document.querySelector('.vioniq-header');
    if (!header) return;

    // Respect the section setting: data-sticky="false" disables sticky
    if (header.dataset.sticky === 'false') return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        header.classList.add('vioniq-is-sticky');
      } else {
        header.classList.remove('vioniq-is-sticky');
      }
    }, { passive: true });
  }

  initMobileMenu() {
    const hamburger   = document.querySelector('.vioniq-hamburger');
    const mobileMenu  = document.querySelector('.vioniq-mobile-menu');
    const body        = document.body;

    if (!hamburger || !mobileMenu) return;

    hamburger.addEventListener('click', () => {
      const isOpen = hamburger.classList.contains('vioniq-is-active');
      hamburger.classList.toggle('vioniq-is-active');
      mobileMenu.classList.toggle('vioniq-is-open');
      hamburger.setAttribute('aria-expanded', String(!isOpen));
      body.style.overflow = isOpen ? '' : 'hidden';
    });

    // Close menu on nav link tap (mobile UX)
    mobileMenu.querySelectorAll('.vioniq-mobile-nav-link').forEach(link => {
      link.addEventListener('click', () => {
        hamburger.classList.remove('vioniq-is-active');
        mobileMenu.classList.remove('vioniq-is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        body.style.overflow = '';
      });
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('vioniq-is-open')) {
        hamburger.classList.remove('vioniq-is-active');
        mobileMenu.classList.remove('vioniq-is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        body.style.overflow = '';
        hamburger.focus();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new VioniqTheme();
});
